export default __webpack_public_path__ + "static/media/14.d4a6aa12.png";